export default __webpack_public_path__ + "static/media/apply_quote.1caa27c1.svg";